import { registerController } from "../registry";

registerController("sidebar", (el: HTMLElement) => {
  const toggle = document.querySelector<HTMLElement>("[data-sidebar-toggle]");
  if (!toggle) return;

  let backdrop: HTMLElement | null = null;

  function open(): void {
    el.classList.add("is-open");
    backdrop = document.createElement("div");
    backdrop.className = "sidebar-backdrop";
    document.body.appendChild(backdrop);
    backdrop.addEventListener("click", close);
  }

  function close(): void {
    el.classList.remove("is-open");
    if (backdrop) {
      backdrop.remove();
      backdrop = null;
    }
  }

  toggle.addEventListener("click", () => {
    if (el.classList.contains("is-open")) {
      close();
    } else {
      open();
    }
  });

  document.addEventListener("keydown", (e: KeyboardEvent) => {
    if (e.key === "Escape" && el.classList.contains("is-open")) {
      close();
    }
  });
});
